export default {
	inUse: {
		// A refused remove: the places that still use what it would take away, each a link to fix.
		heading: "Wird noch verwendet in",
		fixFirst: "Ändern oder entfernen Sie diese zuerst und versuchen Sie es dann erneut.",
		titles: {
			attribute: "Dieses Attribut kann nicht entfernt werden",
			processEntry: "Dieses Datenobjekt kann nicht aus dem Prozess entfernt werden",
		},
		groups: {
			attributes: "Attribute",
			types: "Typen",
			processes: "Prozesse",
		},
		// What the place does with it, said after the place. Keyed by the generator's stable `kind`.
		kinds: {
			writer: "schreibt es",
			listener: "beobachtet es",
			variable: "liest es in einem Feld",
			condition: "Bedingung",
			questionText: "im Text einer Frage",
			suggestion: "schlägt dafür vor",
			graphlyFill: "Graphly-Feld",
			attributeType: "hat diesen Typ",
			annotation: "Typangabe",
			unionMember: "Mitglied einer Union",
			selectDatatype: "Auswahloptionen",
			axiomLiteral: "Axiom",
			operationTemplate: "erstellt daraus ein Datenobjekt",
		},
	},
};
